import { render, staticRenderFns } from "./fount.vue?vue&type=template&id=d27a4a1c&"
import script from "./fount.vue?vue&type=script&lang=js&"
export * from "./fount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d27a4a1c')) {
      api.createRecord('d27a4a1c', component.options)
    } else {
      api.reload('d27a4a1c', component.options)
    }
    module.hot.accept("./fount.vue?vue&type=template&id=d27a4a1c&", function () {
      api.rerender('d27a4a1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/code/batchAddFriends/components/fount.vue"
export default component.exports